import Colors from '../../../../shared/assets/style/default/color';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

function MultiScreenIcon({ focused, height, width }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${height || 17 * Screen.widthRatio}`}
      width={`${width || 22 * Screen.widthRatio}`}
      viewBox={'0 0 22 17'}
    >
      <path
        d='M0 3C0 1.34315 1.34314 0 3 0H16.0213C17.6781 0 19.0213 1.34315 19.0213 3V5.68085H17.0213V3C17.0213 2.44772 16.5736 2 16.0213 2H3C2.44771 2 2 2.44771 2 3V10.0638C2 10.6161 2.44771 11.0638 3 11.0638H5.68085V13.0638H3C1.34315 13.0638 0 11.7207 0 10.0638V3Z'
        clipRule='evenodd'
        fillRule='evenodd'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
      <path
        d='M3.83008 7.68079C3.83008 6.02393 5.17322 4.68079 6.83008 4.68079H19.0003C20.6571 4.68079 22.0003 6.02393 22.0003 7.68079V13.8936C22.0003 15.5504 20.6571 16.8936 19.0003 16.8936H6.83008C5.17322 16.8936 3.83008 15.5504 3.83008 13.8936V7.68079ZM6.83008 6.68079C6.27779 6.68079 5.83008 7.1285 5.83008 7.68079V13.8936C5.83008 14.4458 6.27779 14.8936 6.83008 14.8936H19.0003C19.5526 14.8936 20.0003 14.4458 20.0003 13.8936V7.68079C20.0003 7.1285 19.5526 6.68079 19.0003 6.68079H6.83008Z'
        clipRule='evenodd'
        fillRule='evenodd'
        fill={focused ? Colors['dark'] : Colors['light']}
      />
    </svg>
  );
}

export default MultiScreenIcon;
